var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',{staticClass:"highcharts-figure p-0"},[_c('div',{attrs:{"id":"countries"}},[_c('Chart',{attrs:{"options":_vm.getChartConfig()}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }